<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title="'劳动节-帮助页'"></div>

    <div>劳动节-帮助页</div>

  </div>
</template>
<script>
export default {
  name: 'LaborDay',
  components: {},
  data () {
    return {};
  },
  created () {},
  mounted () {},
  computed: {},
  methods: {}
};
</script>

<style lang="less">
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/tideng/springFestival/help/index.vue